
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '@/services/firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { toast } from 'sonner';

interface ProtectedRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children,
  adminOnly = false
}) => {
  const navigate = useNavigate();
  const [user, loading] = useAuthState(auth);
  
  useEffect(() => {
    if (!loading && !user) {
      navigate('/');
      toast.error('Please login to access this page');
    }
    
    // For admin routes, check if user is admin
    if (adminOnly && user) {
      // This is a simplistic check - in practice, would check a claims token or fetch from Firestore
      if (user.email !== 'info@solarinphoenix.com') {
        navigate('/dashboard');
        toast.error('You do not have permission to access this page');
      }
    }
  }, [user, loading, navigate, adminOnly]);
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-pulse text-xl">Loading...</div>
      </div>
    );
  }
  
  if (!user) {
    return null;
  }
  
  return <>{children}</>;
};

export default ProtectedRoute;
